import React, { MouseEventHandler } from 'react';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { StyledAddFormBloc } from 'components/EmptyAddFormBloc/styled-components';

export interface EmptyAddFormBlocProps {
  title: string;
  buttonBlocTitle: string;
  handleClick?: MouseEventHandler;
  icon?: JSX.Element;
  disabled?: boolean;
}

const EmptyAddFormBloc: React.FC<EmptyAddFormBlocProps> = (
  props,
): JSX.Element => {
  return (
    <StyledAddFormBloc>
      <div className="bloc">
        <div className="title">{props.title}</div>
        <PrimaryButton
          className="add-content-bloc-button"
          title={props.buttonBlocTitle}
          onClick={props!.handleClick}
          lefticon={props.icon}
          disabled={props.disabled}
        />
      </div>
    </StyledAddFormBloc>
  );
};

EmptyAddFormBloc.defaultProps = {
  disabled: false,
};

export default EmptyAddFormBloc;
